/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'network-security-policy';
const componentName = 'network-security-policy-rules-grid';
const prefix = `${moduleName}.${componentName}`;

export const removeButtonLabel = `${prefix}.removeButtonLabel`;
export const editButtonLabel = `${prefix}.editButtonLabel`;
export const addButtonLabel = `${prefix}.addButtonLabel`;
export const enableLabel = `${prefix}.enableLabel`;
export const nameLabel = `${prefix}.nameLabel`;
export const rulesGridTitle = `${prefix}.rulesGridTitle`;

export const ENGLISH = {
    [removeButtonLabel]: 'Remove',
    [editButtonLabel]: 'Edit',
    [addButtonLabel]: 'Add',
    [enableLabel]: 'Enable',
    [nameLabel]: 'Name',
    [rulesGridTitle]: 'Network Security Rules ({0})',
};
